---
de:
  admin:
    time_series_trackers:
      by_source:
        ago: vor {time}
        columns:
          latest_reading: Letzte bekannte Messung
          plants: Anlagen
          source: Quelle
          status: Status
        load_error: Quellenstatus konnte nicht geladen werden.
        never: Nie
        no_plants: Für diese Quelle sind keine aktiven Anlagen konfiguriert.
        no_sources: Keine Quellen gefunden.
        plant_columns:
          latest_reading: Letzte Messung
          plant: Anlage
          signal: Signal
          status: Status
        refresh: Aktualisieren
        search_placeholder: Nach einer Anlage suchen
        show_empty: Quellen ohne Anlagen anzeigen
        signal:
          all: Alle Signale
          heartbeat: Sensor-Heartbeat
          volume: Volumen
        status:
          delayed: Verzögert
          down: Ausgefallen
          no_data: Keine Daten
          up: Aktiv
        subtitle: Ob jede aktive Datenquelle meldet oder ausgefallen ist.
        title: Datenquellenstatus
      tabs:
        by_series: Nach Serie
        by_source: Nach Quelle
